import React, {
    useCallback,
    useState
} from "react";
import PropTypes from "prop-types";
import {
    Alert,
    Button,
    Modal,
    Spinner
} from "react-bootstrap";

function DiscountCodeRemoveProductModal({ show, handleClose, product, onRemove }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const onShow = useCallback(() => {
        setLoading(false);
        setError(null);
    }, []);

    const handleRemove = useCallback(() => {
        if(!product) return;
        setLoading(true);
        setError(null);
        onRemove(product.id, () => {
            handleClose();
        }, (removeError) => {
            setLoading(false);
            setError(removeError);
        });
    }, [product, onRemove, handleClose]);

    return (
        <Modal show={ show } onHide={ handleClose } onShow={ onShow }>
            <Modal.Header closeButton>
                <Modal.Title>Product verwijderen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { error && (
                    <Alert variant="danger">{ error }</Alert>
                )}
                <p className="mb-0">
                    Weet je zeker dat je dit product wil verwijderen uit deze kortingscode?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={ handleClose } disabled={ loading }>
                    Annuleer
                </Button>
                <Button variant="danger" onClick={ handleRemove } disabled={ loading }>
                    { loading && (
                        <Spinner animation="border" variant="light" size="sm" className="mr-2"/>
                    )}
                    Verwijderen
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
DiscountCodeRemoveProductModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    onRemove: PropTypes.func.isRequired,
}

export default React.memo(DiscountCodeRemoveProductModal);
